import { createContext, FC, PropsWithChildren, useContext, useMemo } from 'react';

export interface IFormLoading {
  isLoading: boolean;
  useButtonSpinner: boolean;
}

const Context = createContext<IFormLoading>({
  isLoading: false,
  useButtonSpinner: false
});

/**
 * Used to pass loading state to components wrapped by GenericFormLayout.
 */
export const useFormLoading = (): IFormLoading => {
  const value = useContext(Context);
  return value;
};

export const FormLoadingProvider: FC<PropsWithChildren<IFormLoading>> = ({ children, isLoading, useButtonSpinner }) => {
  const providerValue = useMemo(() => ({ isLoading, useButtonSpinner }), [isLoading, useButtonSpinner]);
  return <Context.Provider value={providerValue}>{children}</Context.Provider>;
};

FormLoadingProvider.displayName = 'FormLoadingProvider';
